import fileDownload from 'js-file-download';

// Receives a base64 string, creates a blob out of it and downloads the file
const downloadPDF = (base64: string, filename: string = 'exported') =>
  fetch(`data:application/pdf;base64,${base64}`)
    .then((res) => res.blob())
    .then((blob) => fileDownload(blob, `${filename}.pdf`));

export default downloadPDF;
